const EmailRegex =
  /^(([^<>()!#~`$^*?/|[\]\\.,;:\s@"]+(\.[^<>()!#~`$^*?/|[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isValidEmail = (email: string): boolean => EmailRegex.test(email.toString())
